import { jsx as _jsx } from "react/jsx-runtime";
import InformationRow from '../../../../common/infoField';
import { SummaryBoxContainer } from './styles';
const SummaryBox = ({ label, Icon, children, className, containerStyle, }) => {
    return (_jsx(SummaryBoxContainer, { className: className, style: containerStyle, children: _jsx(InformationRow, { Icon: Icon, label: label, value: children, size: "md", type: "vertical" }) }));
};
export default SummaryBox;
